<template>
  <section class="document-table">
    <h6 class="document-table__title">{{ title }}</h6>

    <b-table
        :fields="fields"
        :items="items"
        borderless
        responsive
        small
        show-empty
        thead-class="d-none"
        empty-text="No information available"
        class="mb-0"
    >
      <template #cell(label)="data">
        <span class="document-table__label">{{ data.item.label }}</span>
      </template>

      <template #cell(value)="data">
        <b-badge
            v-if="data.item.badge"
            :variant="data.item.variant || 'light-primary'"
        >
          {{ data.item.value }}
        </b-badge>
        <span
            v-else
            :class="[
              'document-table__value',
              { 'document-table__value--money': data.item.money },
            ]"
        >
          {{ data.item.value }}
        </span>
      </template>
    </b-table>
  </section>
</template>

<script>
import { BBadge, BTable } from 'bootstrap-vue'

export default {
  name: 'OrderDocumentCustomTable',
  components: {
    BBadge,
    BTable,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'label',
          label: 'Field',
          tdClass: 'document-table__label-cell',
        },
        {
          key: 'value',
          label: 'Value',
          tdClass: 'text-right',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.document-table {
  height: 100%;
  padding: 1rem;
  border: 1px solid #ebe9f1;
  border-radius: .428rem;
  background: #fff;
}

.document-table__title {
  padding-bottom: .75rem;
  margin-bottom: .25rem;
  color: #5e5873;
  border-bottom: 1px solid #ebe9f1;
}

.document-table__label {
  color: #6e6b7b;
  font-weight: 500;
}

.document-table__value {
  color: #3b3a40;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.document-table__value--money {
  color: #28c76f;
}

::v-deep .table td {
  padding: .65rem .25rem;
  vertical-align: middle;
  border-bottom: 1px dashed #ebe9f1;
}

::v-deep .table tr:last-child td {
  border-bottom: 0;
}

::v-deep .document-table__label-cell {
  width: 48%;
}
</style>
